/* ============================================================
   RZ MOTION - Aktivierung der Scroll-Reveals.
   Scope: Template-Allowlist (siehe ALLOW unten), Gate via
   data-rz-template auf <body> (gesetzt in layout/theme.liquid).
   Kein Framework, ~2 KB. Regeln: Manifest Par. 6.
   Ohne IntersectionObserver oder bei Reduced Motion: no-op,
   Seite bleibt komplett unveraendert.
   Projekt: projekte/mobile-optimierung-2026-07/SPEC.md
   ============================================================ */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.documentElement.classList.add('rz-motion');

  var STAGGER_MS = 90;   /* Versatz zwischen Stagger-Kindern */
  var STAGGER_MAX = 6;   /* Delay-Kappe: max 6 * 90 = 540 ms */

  /* Findet den Wrapper, dessen Kinder gestaggert werden koennen:
     steigt durch Einzel-Kind-Wrapper ab, nimmt die erste Ebene
     mit 2-12 Kindern. Mehr als 12 (lange Listen) -> Block-Reveal. */
  function findStaggerParent(section) {
    var el = section;
    var depth = 0;
    while (el && el.children.length === 1 && depth < 6) {
      el = el.children[0];
      depth++;
    }
    if (el && el.children.length >= 2 && el.children.length <= 12) return el;
    return null;
  }

  /* Rollout-Stufe 2 (19.07.): Start-, Produkt-, Fahrzeug-LP-,
     Hub- und IG-LP-Templates. FAQ/Kontakt/Rechtliches bewusst ohne. */
  function allowed() {
    var t = document.body.getAttribute('data-rz-template') || '';
    if (t === 'index' || t === 'product') return true;
    if (t === 'page.camping-ausbau-v2' || t === 'page.instagram-lp') return true;
    if (t.indexOf('page.campingbox-') === 0) return true; /* 7 Fahrzeug-LPs */
    if (t === 'page.pain-schlafkomfort') return true;
    /* Fallback alte Stufe: Body-Klasse, falls Attribut fehlt */
    return document.body.classList.contains('template-index');
  }

  function setup() {
    if (!allowed()) return;

    var sections = document.querySelectorAll('#MainContent .shopify-section');
    if (!sections.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('rz-in');
        io.unobserve(entry.target);
      });
    /* -18% unten: Reveal startet erst, wenn die Section ~150px in den
       Viewport ragt — sichtbar MITTEN im Bild statt an der Unterkante
       (Kalibrierung 19.07.: bei -8%/0.05 war die Animation praktisch
       unsichtbar, weil sie an der Bildschirmkante schon durchlief). */
    }, { rootMargin: '0px 0px -18% 0px', threshold: 0 });

    Array.prototype.forEach.call(sections, function (sec, idx) {
      if (idx === 0) return; /* Hero nie verstecken (LCP + sofortiger Eindruck) */

      var parent = findStaggerParent(sec);
      if (parent) {
        Array.prototype.forEach.call(parent.children, function (kid, i) {
          kid.classList.add('rz-child');
          kid.style.transitionDelay = Math.min(i, STAGGER_MAX) * STAGGER_MS + 'ms';
        });
      } else {
        sec.classList.add('rz-reveal');
      }
      io.observe(sec);
    });
    /* Kein Zeit-Fallback noetig: der Observer feuert auch fuer Elemente,
       die erst spaeter sichtbar werden; bei fehlendem IO oder
       Reduced Motion wird von vornherein nichts versteckt. */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
